import { catchError, Observable } from "rxjs";
import { ErrorResponse } from "../responses/base.response";
import useNotification from '@ntprsrf-frontend/common/src/components/NtpToast';
import { AxiosResponse } from "axios";

export const notifyError = <T,>(obs: Observable<T>) => {
    const errorNotification = useNotification('danger');
    return obs.pipe(
        catchError((err: any) => {            
            if ((err as ErrorResponse).message) {
                errorNotification('Error', err.message);
            }
            throw err;
        })
    )
}

const getFileName = (response: AxiosResponse<any, any>): string | undefined => {
    if (typeof response.headers['content-disposition'] === 'string') {
        const headerVal: string = response.headers['content-disposition'];
        const fileNamePart = headerVal.includes('=') ? headerVal.split('=')[1] : undefined;
        return fileNamePart?.replace(/^"+|"+$/g, '').trim();
    }
    return undefined;
};

export const downloadFile = (response : AxiosResponse<Blob>) => {
    // console.log('downloadFile', response);
    const successNotification = useNotification("success");
    const isJsonBlob = (data: Blob) => data instanceof Blob && data.type === "application/json";
    // check if response is json, then show message
    if (isJsonBlob(response?.data)) {
        response.data.text().then((text: string) => {
            const res = JSON.parse(text);
            if (res.message) {
                const successNotification = useNotification("success");
                successNotification(
                    "Download In Progress",
                    res.message
                );
            }
        });
        return;
    }
    const fileName = getFileName(response) ?? "report.xlsx";
    const blob = new Blob([response.data], {
        type: "application/octet-stream",
    });
    const link = document.createElement("a");
    link.className = "invisible";
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    link.remove();
    successNotification("Download In Progress", `${fileName} is being downloaded.`);
    return fileName;
}
